import type { GridStateColDef } from "@mui/x-data-grid-premium";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import { Collection } from "ui/support/Resource";
import { withTransaction } from "./TransactionProvider";
import useTransactionDetails from "./useTransactionDetails";
import CurrentTransactionState from "./CurrentTransactionState";
import TransactionActions from "./TransactionActions";

const TransactionDetails = () => {
    const { fromColumns, renderDetailRow } = useTransactionDetails();

    return (
        <Paper
            sx={{
                flex: 1,
                ml: 2,
                width: 'max-content',
                p: 1
            }}
        >
            <TransactionActions />
            <Collection
                collection={fromColumns()}
                renderResource={(column: GridStateColDef) => (
                    <Stack
                        key={column.field}
                        direction='row'
                        spacing={3}
                        py={1}
                        px={2}
                    >
                        <Box
                            sx={{
                                fontWeight: 'bold'
                            }}
                        >
                            {column.headerName}:
                        </Box>
                        <Box
                            sx={{
                                userSelect: 'all'
                            }}
                        >
                            {renderDetailRow(column)}
                        </Box>
                    </Stack>
                )}
            />
            <CurrentTransactionState />
        </Paper>
    );
};

export default withTransaction(TransactionDetails);
